var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover",class:{ 'cover--started': _vm.started },on:{"click":_vm.start}})}
var staticRenderFns = []

export { render, staticRenderFns }